// components/sections/SocialLifeSection.tsx
import React from "react";
import { Home, Users, School } from "lucide-react";
import { TextAreaField, CheckboxField, InputField } from "../form/FormComponents_PediatricsRegistration";
import type { FormData } from "../../types/consultation";

interface SocialLifeSectionProps {
  formData: FormData;
  updatePediatricsInfo: (field: string, value: string | boolean) => void;
  updateVieSociale: (field: string, value: string | boolean) => void;
}

export const SocialLifeSection: React.FC<SocialLifeSectionProps> = ({
  formData,
  updatePediatricsInfo,
  updateVieSociale,
}) => {
  return (
    <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-2xl shadow-lg border border-teal-100">
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <Home className="mr-2 text-teal-600" size={24} />
        Vie Sociale
      </h3>

      <div className="space-y-6">
        <TextAreaField
          label="Avec qui vit le patient"
          value={formData.pediatrieInfo?.patientVitAvec || ""}
          onChange={(value) => updatePediatricsInfo("patientVitAvec", value)}
          icon={Users}
          placeholder="Décrivez l'environnement familial..."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <CheckboxField
              label="Y a-t-il des animaux à la maison"
              checked={formData.vieSociale.animauxMaison}
              onChange={(checked) =>
                updateVieSociale("animauxMaison", checked)
              }
            />

            {formData.vieSociale.animauxMaison && (
              <InputField
                label="Si oui, de quel genre"
                value={formData.vieSociale.genreAnimaux || ""}
                onChange={(value) => updateVieSociale("genreAnimaux", value)}
                placeholder="Type d'animaux..."
              />
            )}
          </div>

          <CheckboxField
            label="Est-ce que quelqu'un à la maison fume du tabac"
            checked={formData.vieSociale.fumeurMaison}
            onChange={(checked) => updateVieSociale("fumeurMaison", checked)}
          />
        </div>

        <TextAreaField
          label="L'enfant va-t-il à la garderie ou à l'école ?"
          value={formData.pediatrieInfo?.vaGarderieEcole || ""}
          onChange={(value) => updatePediatricsInfo("vaGarderieEcole", value)}
          icon={School}
          placeholder="Précisez le nom, la classe ou le type d'établissement..."
        />

        <CheckboxField
          label="L'enfant est-il fumeur ?"
          checked={formData.vieSociale.fumeur}
          onChange={(checked) => updateVieSociale("fumeur", checked)}
        />

        {formData.vieSociale.fumeur && (
          <InputField
            label="Nombre de cigarettes par jour"
            value={formData.vieSociale.cigarettesParJour || ""}
            onChange={(value) => updateVieSociale("cigarettesParJour", value)}
            type="number"
            placeholder="Ex: 5"
          />
        )}
      </div>
    </div>
  );
};